import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon
} from 'react-share'
import { Container } from './styles'
import { useAuth } from '~/contexts'
import { Dropdown } from '../Dropdown'
import { Button, Card, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material'
import { IconShare } from '@tabler/icons-react'
import { useCallback, useEffect, useState } from 'react'

export const ShareSocialMediaLinks: React.FC = () => {
  const { authUser } = useAuth()
  const theme = useTheme()
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))
  const [share, setShare] = useState<string | null>(null)
  const widthBox = useCallback(() => {
    if (isLowerSm) {
      if (share) {
        return {
          left: '0',
          top: '60px'
        }
      } else {
        return {
          left: '0',
          top: '60px'
        }
      }
    }
    else {
      if (share) {
        return {
          left: '180px',
          top: '6px'
        }
      } else {
        return {
          left: '190px',
          top: '5px'
        }
      }
    }
  }, [share, isLowerSm])

  const width = widthBox()

  useEffect(() => {
    console.log(share);

  }, [share])

  useEffect(() => {
    if (authUser) {
      if (process.env.VITE_APP_ENV === 'production') {
        setShare(`https://despertaenergia.com/indicacao/${authUser.indicationCode}`)
      } else {
        setShare(`https://alpha--desperta-landing.netlify.app/indicacao/${authUser.indicationCode}`)
      }
    }
  }, [])

  return (
    <Dropdown
      // customClose={() => setShare(null)}
      $options={{ left: width.left, top: width.top }}
      elementClick={
        <Button
          endIcon={<IconShare size={24} />}
          color='secondary'
        >
          Compartilhar
        </Button>
      }
    >
      <Container>
        <FacebookShareButton url={share!}>
          <FacebookIcon size={32} round={true} />
        </FacebookShareButton>
        <WhatsappShareButton url={share!}>
          <WhatsappIcon size={32} round={true} />
        </WhatsappShareButton>
        <TwitterShareButton url={share!}>
          <TwitterIcon size={32} round={true} />
        </TwitterShareButton>
        <TelegramShareButton url={share!}>
          <TelegramIcon size={32} round={true} />
        </TelegramShareButton>
        <LinkedinShareButton url={`https://www.linkedin.com/sharing/share-offsite/?url=${share}`}>
          <LinkedinIcon size={32} round={true} />
        </LinkedinShareButton>
      </Container>


    </Dropdown >
  )
}
